<script>
import pdf_logo from "@/assets/pdf_logo.png";
export default {
    name: "previewHeader",
    props: {
        companyName: {
            type: String,
            default: ""
        },
        riskName: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            pdf_logo
        }
    }
};
</script>

<template>
    <div :data-key="`${companyName}_${riskName}`" class="preview-header-wrapper">
        <div class="preview-header">
            <div class="title-wrapper fz28 golden bold">
                <span>{{companyName}}</span> <span v-if="riskName">-</span> <span>{{riskName}}</span>
            </div>
            <img class="logo" :src="pdf_logo" alt="">
<!--            <div class="logo" :style="`background-image: url(${pdf_logo});`"></div>-->
        </div>
        <div class="preview-header_bottom"></div>
    </div>
</template>

<style scoped lang="less">
.preview-header-wrapper {
    padding-bottom: 20px;
}
.preview-header {
    margin: 0 auto;
    width: 1180px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
        height: 60px;
        width: 340px;
        background-size: 340px 60px;
        background-repeat: no-repeat;
    }
    .fz28 {
        font-size: 28px;
    }
    .bold {
        font-weight: bold;
    }
    .golden {
        color: #C7A976;
    }
}
.preview-header_bottom {
    width: 100%;
    height: 25px;
    background-color: rgba(179, 152, 100, 1);
}
</style>